// extracted by mini-css-extract-plugin
export var buttonBar = "ArticleSummary-Block-module--buttonBar--drGtJ";
export var card = "ArticleSummary-Block-module--card--3iYrJ";
export var copy = "ArticleSummary-Block-module--copy--NcWXq";
export var image = "ArticleSummary-Block-module--image--hSXfE";